import React, { useMemo, useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { Router } from '@reach/router';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { FocusStyleManager } from '@el8/vital';

import { useStripePublishableKey } from 'modules/payments';
import { initAmplitude, logEvent } from 'utils/amplitude';
import PublicPaymentPage from 'views/payments/PublicPaymentPage/PublicPaymentPage';
import CardDetailsPage from 'views/payments/CardDetailsPage/CardDetailsPage';
import PatientMembershipPage from 'views/payments/PatientMembershipPage';
import PaymentChargePage from 'views/payments/PaymentChargePage/PaymentChargePage';
import PaymentRequestPage from 'views/payments/PaymentRequestPage/PaymentRequestPage';

import './PaymentsApp.less';

FocusStyleManager.onlyShowFocusOnTabs();
initAmplitude();

export const PaymentsApp: React.FC = () => {
  useEffect(() => logEvent('load payment site'), []);
  const [publishableKey] = useStripePublishableKey();

  const stripePromise = useMemo(() => (publishableKey ? loadStripe(publishableKey) : null), [
    publishableKey,
  ]);

  if (!stripePromise) return null;

  return (
    <Elements stripe={stripePromise}>
      <Router>
        <PublicPaymentPage path="pay/:slug" />
        <CardDetailsPage path="patient/:patientId/card-details" />
        <PaymentChargePage path="payment-charge/:paymentChargeId/view" />
        <PaymentRequestPage path="payment-request/:paymentRequestId/view" />
        <PatientMembershipPage path="patient-membership-subscriptions/:subscriptionId/view/" />
      </Router>
    </Elements>
  );
};

export default hot(module)(PaymentsApp);
